import React from 'react'
import styled, { css } from 'styled-components'
import { Radar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'
import { ModelParams } from 'apps/placeme/src/features/Analyse/components/organisms/Tiles/Potential/SalesPotential/@types/ISalesPotentialTileData'
import { SalesPotentialLabels } from 'apps/placeme/src/features/Analyse/components/organisms/Tiles/Potential/SalesPotential/data'
import { IRadarChartProps } from './@types/IRadarChart.props'

const RadarWrapper = styled.div`
  padding: 30px 0;
`
const Label = styled.div(({ theme }) => {
  const {
    palette, typography,
  } = theme
  return css`
  display: flex;
  width: 100%;
  justify-content: space-between;
  color: ${palette.black};
  margin-top: 30px;

  > span {
    font-size: ${typography.tiny.pt_12_regular.fontSize};
    font-weight: ${typography.tiny.pt_12_regular.fontWeight};
    line-height: ${typography.tiny.pt_12_regular.lineHeight};
  }
` })

export const getRadarChartData = (data: ModelParams): number[] =>
  data && Object.values(data)?.map(value => value?.influence)

export const getRadarChartLabels = (data: ModelParams, labels: SalesPotentialLabels): string[] =>
  data && Object.keys(data)?.map(key => labels?.find(label => label?.key === key)?.valueForChart || labels?.find(label => label?.key === key)?.value || 'Value')

export const RadarChart = ({
  data, labels, secondData,
}: IRadarChartProps): JSX.Element => {
  const { t } = useTranslation()

  const dataset = {
    labels: labels?.map(label => t(`${label}`)),
    datasets: secondData
      ? [
        {
          label: '',
          borderWidth: 1,
          backgroundColor: 'rgba(54, 47, 183, 0.3)',
          borderColor: '#362FB7',
          lineTension: 0,
          pointBorderWidth: 1.5,
          pointRadius: 1,
          data,
        },
        {
          label: '',
          borderWidth: 1,
          backgroundColor: 'rgba(216, 168, 0, 0.3)',
          borderColor: '#D8A800',
          lineTension: 0,
          pointBorderWidth: 1.5,
          pointRadius: 1,
          data : secondData,
        },
      ]
      : [
        {
          label: '',
          borderWidth: 1,
          backgroundColor: 'rgba(54, 47, 183, 0.3)',
          borderColor: '#362FB7',
          lineTension: 0,
          pointBorderWidth: 1.5,
          pointRadius: 1,
          data,
        },
      ],
  }
  return (
    <RadarWrapper>
      <Radar
        data={dataset}
        options={{
          legend: {
            display: false,
          },
          plugins: {
            datalabels: {
              display: false,
            },
          },
          tooltips: {
            enabled: false,
          },
          scale: {
            pointLabels: {
              fontSize: 11,
            },
            ticks: {
              beginAtZero: true,
              min: 0,
              maxTicksLimit: data?.length,
            },
          },

        }}
      />
      <Label>
        <span><strong>{t('placeme.sales_potential_tile.radar.legend.key')}</strong></span>

        <span>
          {`1 - ${t('placeme.sales_potential_tile.radar.legend.value.lowest')}  ${Math.max(...data ?? [])} - ${t('placeme.sales_potential_tile.radar.legend.value.highest')}`}
        </span>
      </Label>
    </RadarWrapper>
  )
}
